import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import audio from "assets/videos/audio.mp3";
import { useState } from "react";
const PostMedia6 = () => {
    const [deleted, setDeleted] = useState(false);
    return (
        <>
            <div className="post-image"></div>
            <div className="post-image">
                {deleted && (
                    <div className="w-full text-start">
                        <p className="text-red-500">Audio Deleted</p>
                    </div>
                )}
                <AudioPlayer
                    // src="http://example.com/audio.mp3"
                    src={audio}
                    // onPlay={(e) => console.log("onPlay")}
                    // other props here
                />
                <div className="text-center pt-3">
                    <button
                        className={`${deleted ? "bg-momeento-50" : "bg-red-600"} text-white text-center rounded-full w-fit px-3 py-1`}
                        onClick={() => setDeleted(!deleted)}
                    >
                        {deleted ? "Restore Audio" : "Delete Audio"}
                    </button>
                </div>
            </div>
        </>
    );
};

export default PostMedia6;
